import React from 'react';
import './EventInfoView.css';

const EventInfoView = ({ isOpen, onClose, event, locations }) => {
  if (!isOpen || !event) return null;

  const locationDetails = locations.find(loc => loc.name === event.location);
  return (
    <div className="event-info-modal-overlay">
    <div className="event-info-modal">
      <button className="close-btn" onClick={onClose}>×</button>
      <h2>Shift Details</h2>
  
      <table className="event-info-table">
        <tbody>
          <tr>
            <td><strong>User:</strong></td>
            <td>{event.title}</td>
          </tr>
          <tr>
            <td><strong>Date:</strong></td>
            <td>{event.date || new Date(event.start).toLocaleDateString()}</td>
          </tr>
          <tr>
            <td><strong>Time:</strong></td>
            <td>
              {event.startTime || new Date(event.start).toLocaleTimeString()} -{' '}
              {event.endTime || new Date(event.end).toLocaleTimeString()}
            </td>
          </tr>
          <tr>
            <td><strong>Location:</strong></td>
            <td>{event.location}</td>
          </tr>
          <tr>
            <td><strong>Type:</strong></td>
            <td>{locationDetails.type}</td>
          </tr>
          <tr>
            <td><strong>Description:</strong></td>
            <td>{locationDetails.notes}</td>
          </tr>
          {locationDetails && (
            <tr>
              <td><strong>Location Address:</strong></td>
              <td>{locationDetails.addres}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
  
  );
};

export default EventInfoView;
